const getFromLocalStorage = (userId, prop) => {
  const data = JSON.parse(localStorage.getItem(userId));
  return data?.[prop];
};

export default getFromLocalStorage;